import React from 'react';
import { CheckCircle } from 'lucide-react';

const icons = {
  recent: (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  ),
  popular: (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
    </svg>
  ),
  random: (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h1m0-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  )
};

const FeaturedAlbumsSection = ({ featuredAlbums, selectedAlbumId, onSelect }) => {
  if (!featuredAlbums.length) {
    return null;
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
      {featuredAlbums.map(album => {
        const isSelected = selectedAlbumId === album.id;

        return (
          <div
            key={album.id}
            onClick={() => onSelect(album.id)}
            className={`relative cursor-pointer rounded-xl p-4 border-2 transition-all duration-200 hover:scale-105 ${
              isSelected
                ? 'border-blue-500 bg-blue-50 shadow-lg'
                : 'border-gray-200 hover:border-blue-300 hover:shadow-md bg-white'
            }`}
          >
            <div className="flex items-center space-x-3 mb-3">
              <div className={`p-2 rounded-lg ${isSelected ? 'bg-blue-500 text-white' : 'bg-gray-100 text-gray-600'}`}>
                {icons[album.featuredType]}
              </div>
              <div className="flex-1">
                <h3 className={`font-semibold ${isSelected ? 'text-blue-900' : 'text-gray-900'}`}>
                  {album.featuredTitle}
                </h3>
                <p className={`text-sm ${isSelected ? 'text-blue-600' : 'text-gray-500'}`}>
                  {album.featuredDescription}
                </p>
              </div>
              {isSelected && (
                <CheckCircle className="w-5 h-5 text-blue-500" />
              )}
            </div>

            <div className="flex items-center space-x-3">
              {album.thumbnailUrl && (
                <div className="w-12 h-12 rounded-lg overflow-hidden bg-gray-100 flex-shrink-0">
                  <img
                    src={album.thumbnailUrl}
                    alt=""
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      e.target.style.display = 'none';
                    }}
                  />
                </div>
              )}
              <div className="flex-1">
                <p className={`font-medium truncate ${isSelected ? 'text-blue-900' : 'text-gray-900'}`}>
                  {album.title || 'Untitled Album'}
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default FeaturedAlbumsSection;
